<div class="modal-header" id="confirmation-add-material-modal-title">
    <h3 class="modal-title" id="modal-title" translate="CONFIRMATION_MATERIAL_ADDMATERIAL_HEADER"></h3>
    <span class="close" (click)="modalInstance.hide()">&times;</span>
</div>
<div class="modal-body" id="modal-body">
    <form [formGroup]="confirmationAddMaterialForm">
        <fieldset formArrayName="formChildren">
            <!--AWB Number-->
            <div class="row mb-3 align-items-center">
                <label
                    class="col-sm-4 col-form-label text-sm-end text-start"
                    *ngIf="displayAWBNumber"
                    translate="CONFIRMATION_MATERIAL_ADDMATERIAL_AWB"
                ></label>
                <label
                    class="col-sm-4 col-form-label text-sm-end text-start"
                    *ngIf="displayBatchNumber"
                    translate="CONFIRMATION_MATERIAL_ADDMATERIAL_BATCHNR"
                ></label>
                <div class="col-sm-6" *ngIf="displayAWBNumber || displayBatchNumber">
                    <pace-core-text-input
                        id="awb"
                        name="awb"
                        [(model)]="model.newMaterial.awbReturn"
                        [parentForm]="confirmationAddMaterialFormChildren"
                        [ariaLabel]="'CONFIRMATION_MATERIAL_ADDMATERIAL_BATCHNR' | translate"
                    ></pace-core-text-input>
                </div>
            </div>
            <!--Material Number-->
            <div class="row mb-3 align-items-center">
                <label
                    class="col-sm-4 col-form-label text-sm-end text-start"
                    translate="CONFIRMATION_MATERIAL_ADDMATERIAL_MATNO"
                ></label>
                <div class="col-sm-6">
                    <pace-core-text-input
                        id="materialNumber"
                        name="materialNumber"
                        [(model)]="model.newMaterial.materialIdentifier.materialNumber"
                        [parentForm]="confirmationAddMaterialFormChildren"
                        [ariaLabel]="'CONFIRMATION_MATERIAL_ADDMATERIAL_MATNO' | translate"
                    ></pace-core-text-input>
                </div>
            </div>
            <!--Material Description-->
            <div class="row mb-3 align-items-center">
                <label
                    class="col-sm-4 col-form-label text-sm-end text-start"
                    translate="CONFIRMATION_MATERIAL_ADDMATERIAL_DESC"
                ></label>
                <div class="col-sm-6">
                    <pace-core-text-input
                        id="description"
                        name="description"
                        [(model)]="model.newMaterial.description"
                        [parentForm]="confirmationAddMaterialFormChildren"
                        [ariaLabel]="'CONFIRMATION_MATERIAL_ADDMATERIAL_DESC' | translate"
                    ></pace-core-text-input>
                </div>
            </div>
            <!--Material type-->
            <div class="row mb-3 align-items-center">
                <label
                    class="col-sm-4 col-form-label text-sm-end text-start"
                    translate="CONFIRMATION_MATERIAL_ADDMATERIAL_TYPE"
                ></label>
                <div class="col-sm-6">
                    <pace-core-dropdown
                        [(model)]="model.materialType"
                        id="dropdownMaterialType"
                        [parentForm]="confirmationAddMaterialFormChildren"
                        (valueChange)="onTypeChange()"
                    ></pace-core-dropdown>
                </div>
            </div>
            <!--Order Number-->
            <div class="row mb-3 align-items-center">
                <label
                    class="col-sm-4 col-form-label text-sm-end text-start"
                    translate="CONFIRMATION_MATERIAL_ADDMATERIAL_ORDERNO"
                ></label>
                <div class="col-sm-6">
                    <pace-core-text-input
                        id="orderNumber"
                        name="orderNumber"
                        [(model)]="model.newMaterial.materialIdentifier.orderNumber"
                        [parentForm]="confirmationAddMaterialFormChildren"
                        [ariaLabel]="'CONFIRMATION_MATERIAL_ADDMATERIAL_ORDERNO' | translate"
                    ></pace-core-text-input>
                </div>
            </div>
            <!--Order Position-->
            <div class="row mb-3 align-items-center">
                <label
                    class="col-sm-4 col-form-label text-sm-end text-start"
                    translate="CONFIRMATION_MATERIAL_ADDMATERIAL_ORDERPO"
                ></label>
                <div class="col-sm-6">
                    <pace-core-text-input
                        id="orderPosition"
                        name="orderPosition"
                        [(model)]="model.newMaterial.materialIdentifier.orderPosition"
                        [parentForm]="confirmationAddMaterialFormChildren"
                        [ariaLabel]="'CONFIRMATION_MATERIAL_ADDMATERIAL_ORDERPO' | translate"
                    ></pace-core-text-input>
                </div>
            </div>
            <!--Material Quantity-->
            <div class="row mb-3 align-items-center">
                <label
                    class="col-sm-4 col-form-label text-sm-end text-start"
                    translate="CONFIRMATION_MATERIAL_ADDMATERIAL_QUANTITY"
                ></label>
                <div class="col-sm-6">
                    <pace-core-number-stepper
                        id="quantity"
                        name="quantity"
                        [(model)]="model.newMaterial.quantity"
                        [parentForm]="confirmationAddMaterialFormChildren"
                        [ariaLabel]="'CONFIRMATION_MATERIAL_ADDMATERIAL_QUANTITY' | translate"
                    ></pace-core-number-stepper>
                </div>
            </div>
            <!--Material Price-->
            <div class="row mb-3 align-items-center">
                <label
                    class="col-sm-4 col-form-label text-sm-end text-start"
                    translate="CONFIRMATION_MATERIAL_ADDMATERIAL_PRICE"
                ></label>
                <div class="col-sm-6">
                    <pace-core-number-input
                        id="price"
                        name="price"
                        [(model)]="model.newMaterial.amount"
                        [parentForm]="confirmationAddMaterialFormChildren"
                        [ariaLabel]="'CONFIRMATION_MATERIAL_ADDMATERIAL_PRICE' | translate"
                    ></pace-core-number-input>
                </div>
            </div>
        </fieldset>
    </form>
</div>
<div class="modal-footer">
    <button
        class="btn btn-primary"
        *ngIf="!pickupRunning"
        [disabled]="confirmationAddMaterialForm.invalid"
        (click)="pickup()"
        translate="CONFIRMATION_MATERIAL_ADDMATERIAL_PICKUP"
    ></button>
    <progressbar *ngIf="pickupRunning" [value]="100" type="default">
        {{ 'CONFIRMATION_MATERIAL_ADDMATERIAL_LOADING_MESSAGE' | translate }}
    </progressbar>
</div>
